// extracted by mini-css-extract-plugin
module.exports = {"winning-bet":"styles_winning-bet__6DSzI","fadeOutUp":"styles_fadeOutUp__Vehk_","winning-animation":"styles_winning-animation___dq1t","number":"styles_number__gfL48"};